module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo02-0ad7669d5ae70422de1b086e252db5d1.png";